export default __webpack_public_path__ + "static/media/slot-cat-cn.e9163235.webp";